import Vue from 'vue';
import VueCookie from 'vue-cookie';
import { cookieConstant } from '../constants/cookie';

Vue.prototype.$cookieConstants = cookieConstant;
Vue.use(VueCookie);
